import type { MouseEvent } from 'react';

// Ventanas de solo lectura (2026-10-30, pedido de Milenko): se cierran al tocar el fondo oscuro, pero
// solo si el toque EMPIEZA y TERMINA en el fondo. Antes, seleccionar texto arrastrando y soltar fuera
// del recuadro contaba como "clic en el fondo" y cerraba la ventana. Las ventanas donde se escribe
// o se cobra ya no se cierran al tocar afuera: solo con la X o Cancelar.
export const cerrarAlTocarFondo = (cerrar: () => void) => ({
  onMouseDown: (e: MouseEvent<HTMLElement>) => { e.currentTarget.dataset.toqueFondo = e.target === e.currentTarget ? '1' : ''; },
  onClick: (e: MouseEvent<HTMLElement>) => {
    const empezoEnFondo = e.currentTarget.dataset.toqueFondo === '1';
    e.currentTarget.dataset.toqueFondo = '';
    if (empezoEnFondo && e.target === e.currentTarget) cerrar();
  },
});
